/**
 * aswbe checkin eapi
 * チェックイン業務で利用するAPIを提供する
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PostJourneysGetJourneyResponseDataFlightsInnerOperationStatusWeatherCheck } from './postJourneysGetJourneyResponseDataFlightsInnerOperationStatusWeatherCheck';

/**
 * 最新運航情報
 */
export interface PostJourneysGetJourneyResponseDataFlightsInnerOperationStatus {
  /**
   * 運航ステータス<br> scheduled:正常（遅延・早発・欠航のいずれにも該当しない場合）<br> delayed:遅延（計画出発日時よりも最新出発日時が遅い場合）<br> earlyDeparture:早発（計画出発日時よりも最新出発日時が早い場合）<br> cancelled:欠航（セグメントステータス=\"UN\"の場合）
   */
  status: PostJourneysGetJourneyResponseDataFlightsInnerOperationStatus.StatusEnum;
  /**
   * 発着APIから取得した遅延・欠航および天候調査理由
   */
  reason?: string;
  weatherCheck?: PostJourneysGetJourneyResponseDataFlightsInnerOperationStatusWeatherCheck;
}
export namespace PostJourneysGetJourneyResponseDataFlightsInnerOperationStatus {
  export type StatusEnum = 'scheduled' | 'delayed' | 'earlyDeparture' | 'cancelled';
  export const StatusEnum = {
    Scheduled: 'scheduled' as StatusEnum,
    Delayed: 'delayed' as StatusEnum,
    EarlyDeparture: 'earlyDeparture' as StatusEnum,
    Cancelled: 'cancelled' as StatusEnum,
  };
}
